// extracted by mini-css-extract-plugin
module.exports = {"base":"LandingPageHeader-module-base"};